export default __webpack_public_path__ + "static/media/andor2.0d223af8.jpeg";